export function ValidateEmail(inputText) {
    // Regex for email validation
    var mailformat = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return mailformat.test(inputText);
}
